import React from 'react';
import CommonHeader from '../components/common/CommonHeader';
import CommonFooter from '../components/common/CommonFooter';
import Newsfeed from '../components/News/NewsFeed';
import TradingViewWidget from '../components/News/TradingViewWidget';
import NewsfeedIndia from '../components/News/NewsfeedIndia';
import NewsfeedUSA from '../components/News/NewsfeedUSA';
import NewsfeedCommodities from '../components/News/NewsfeedCommodities';
import SeoMeta from '../components/SEO/SeoMeta';

export default function NewsPage() {
  return (
    <div className="bg-black text-white">
      <SeoMeta
        title="Live Financial Market News – M2T Verified Stream"
        description="Live news from verified sources: Indian, US, Crypto & Commodities markets. Powered by CNBC, ET, CryptoSlate, and Investing.com."
        keywords="financial news, stock market updates, crypto news, trading headlines, commodities news, CNBC, ET Markets, Million2Trillion"
        url="https://million2trillion.com/news"
        canonical="https://million2trillion.com/news"
      />

      <CommonHeader />

      <main className="min-h-screen py-10 px-4 sm:px-10">
        <div className="max-w-6xl mx-auto space-y-10">
          {/* Header */}
          <header className="text-center space-y-4">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-purple-400">
              Live Market News — Powered by Trusted Sources
            </h1>
            <p className="text-gray-400 max-w-3xl mx-auto text-lg">
              Stay updated with the latest news across financial markets, trading trends, global policies,
              and tech developments — embedded directly from licensed providers.
            </p>
          </header>

          {/* Disclaimer */}
          <section className="bg-black border border-gray-700 rounded-xl p-6 shadow-md">
            <h2 className="text-xl font-semibold text-red-400 mb-2">⚠️ Disclaimer & Source Notice</h2>
            <p className="text-gray-300 text-sm">
              The following news feed is provided via embedded or authorized third-party sources.
              Million2Trillion does not claim ownership of any news content displayed below.
              All copyrights and trademarks belong to their respective owners.
              News is displayed as-is for user convenience, and should not be considered official financial advice.
              Always do your own research before acting on market information.
            </p>
          </section>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
  {/* TradingView Widget Card */}
  <div className="bg-black border border-gray-700 rounded-lg shadow-md p-4">
    <h3 className="text-lg font-semibold text-white mb-3">Live Trading View News</h3>
    <TradingViewWidget />
  </div>

  {/* Crypto News Feed Card */}
  <div className="bg-black border border-gray-700 rounded-lg shadow-md p-4">
    <h3 className="text-lg font-semibold text-white mb-3">🪙 Latest Crypto News</h3>
    <Newsfeed />
  </div>
</div>


          {/* Additional News Sections */}
          <div className="bg-black rounded-lg overflow-hidden shadow-lg p-4">
            <h3 className="text-lg font-semibold text-white mb-3">🇺🇸 Latest U.S. Market News (CNBC)</h3>
            <NewsfeedUSA />
          </div>

          <div className="bg-black rounded-lg overflow-hidden shadow-lg p-4">
            <h3 className="text-lg font-semibold text-white mb-3">🇮🇳 Indian Market News (ET Markets)</h3>
            <NewsfeedIndia />
          </div>

          <div className="bg-black rounded-lg overflow-hidden shadow-lg p-4">
            <h3 className="text-lg font-semibold text-white mb-3">🛢️ Commodities Market News (Gold, Oil, Metals)</h3>
            <NewsfeedCommodities />
          </div>

          {/* Static SEO Text */}
          <section className="text-sm text-gray-300 max-w-4xl mx-auto mt-8 space-y-2">
            <h2 className="text-lg font-bold text-white mb-2">About the M2T Live News Feed</h2>
            <p>
              The Million2Trillion News Hub is a trusted gateway to real-time market updates for traders,
              analysts, coders, educators, and financial professionals worldwide.
              All content is sourced directly from authorized providers like CNBC, ET Markets, CryptoSlate,
              and Investing.com using legal and licensed methods.
            </p>
            <p>
              We display only headlines and excerpts with direct links to source articles.
              M2T does not rewrite, copy, or distribute news but acts as a verified platform for
              market-aware engagement and SmartCard-verified professional insight.
            </p>
            <p>
              Whether you're tracking the NIFTY, Dow Jones, crude oil, or the latest in crypto,
              this stream is tailored for those building value in the real financial world.
            </p>
          </section>

          {/* Footer Notice */}
          <div className="text-center text-gray-500 text-xs mt-10">
            <p>
              Million2Trillion is not responsible for any financial loss arising from external content.
              Use this news feed as informational input only. For reporting issues with embedded news,
              contact <a href="mailto:support@million2trillion.com" className="underline">support@million2trillion.com</a>.
            </p>
          </div>
        </div>
      </main>

      <CommonFooter />
    </div>
  );
}
